// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Record from "../Record/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_WeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var fixRecord = function (dict) {
    return dict.fixRecord;
};
var fixFRPRecordNil = function (dictTypeEquals) {
    return {
        fixRecord: function (dictMonadFRP) {
            return function (v) {
                return function (f) {
                    return Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(Data_Tuple.snd)(f(Type_Equality.to(dictTypeEquals)({})));
                };
            };
        }
    };
};
var fixFRPRecord = function (dictFixFRPRecord) {
    return function () {
        return {
            fixFRP: function (dictMonadFRP) {
                return fixRecord(dictFixFRPRecord)(dictMonadFRP)(Type_Proxy["Proxy"].value);
            }
        };
    };
};
var fixFRP = function (dict) {
    return dict.fixFRP;
};
var fixFRPRecordCons = function (dictIsSymbol) {
    return function () {
        return function () {
            return function () {
                return function () {
                    return function (dictFixFRP) {
                        return function (dictFixFRPRecord) {
                            return {
                                fixRecord: function (dictMonadFRP) {
                                    return function (v) {
                                        return function (f) {
                                            return fixFRP(dictFixFRP)(dictMonadFRP)(function (v1) {
                                                return fixRecord(dictFixFRPRecord)(dictMonadFRP)(Type_Proxy["Proxy"].value)(function (v2) {
                                                    var ri = Record.insert(dictIsSymbol)()()(Type_Proxy["Proxy"].value)(v1)(v2);
                                                    return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(f(ri))(function (v3) {
                                                        var output = Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(v3.value0);
                                                        var tail_ro = Record["delete"](dictIsSymbol)()()(Type_Proxy["Proxy"].value)(v3.value0);
                                                        return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(new Data_Tuple.Tuple(tail_ro, new Data_Tuple.Tuple(output, v3.value1)));
                                                    });
                                                });
                                            });
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
var fixFRP_ = function (dictFixFRP) {
    return function (dictMonadFRP) {
        return function (f) {
            return fixFRP(dictFixFRP)(dictMonadFRP)(function (input) {
                return Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(function (x) {
                    return new Data_Tuple.Tuple(x, Data_Unit.unit);
                })(f(input));
            });
        };
    };
};
var fixEvent = function (dictMonadFRP) {
    return function (f) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0()))(function (v) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(f(v.event))(function (v1) {
                return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.subscribeEvent_(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(v.fire)(v1.value0))(function () {
                    return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(v1.value1);
                });
            });
        });
    };
};
var fixFRPEvent = {
    fixFRP: function (dictMonadFRP) {
        return fixEvent(dictMonadFRP);
    }
};
var fixDyn = function (dictMonadFRP) {
    return function (f) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0()))(function (v) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_WeakDynamic.holdWeakDyn(dictMonadFRP)(v.event))(function (wdyn) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(f(wdyn))(function (v1) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.subscribeDyn_(dictMonadFRP)(v.fire)(v1.value0))(function () {
                        return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(v1.value1);
                    });
                });
            });
        });
    };
};
var fixFRPDynamic = {
    fixFRP: function (dictMonadFRP) {
        return fixDyn(dictMonadFRP);
    }
};
export {
    fixDyn,
    fixEvent,
    fixFRP,
    fixFRP_,
    fixRecord,
    fixFRPEvent,
    fixFRPDynamic,
    fixFRPRecord,
    fixFRPRecordNil,
    fixFRPRecordCons
};
//# sourceMappingURL=index.js.map
